var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"secondary darken-1",attrs:{"align-center":"","justify-center":""}},[_c('v-img',{attrs:{"src":"/img/recipe_placeholder.png","max-height":"100%","max-width":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }